// filters.js
var DKT = DKT || {};
DKT.filters = function($, DKTConfiguration, DKTUtils, DKTMap, DKTPaths, existeGoogleAnalytics) {
  var initialTamborradas;
  var filteredTamborradas;
  var isQuarterPage = false;

  function commonInitialization(tamborradas) {
    var time = getFilterPositionForActualTime();
    subscribeSliderListener();
    saveInitialState(tamborradas);
    initializeSlider(time);
  }

  function init() {
    if (!isQuarterPage) {
      var tamborradas = DKTPaths.getTamborradas();
      commonInitialization(tamborradas);
    }
  }

  function initQuarterPage(tamborradas) {
    isQuarterPage = true;
    commonInitialization(tamborradas);
  }

  function saveInitialState(tamborradas) {
    initialTamborradas = tamborradas;
  }

  function initializeSlider(time) {
    $("#range_tamborradas").val(time);
    $("#range_tamborradas").trigger("input");
  }

  function filterByHour(e) {
    DKTMap.getMyMap().closePopup();
    var hourFilterPlaceholder = $(".slider-output");
    var value = Number(e.target.value);
    if (value === 0) {
      hourFilterPlaceholder.text("--:--");
      applyInitialState();
    } else {
      var filterHour = Math.floor((value - 1) / 4);
      var filterMinute = ((value - 1) % 4) * 15;

      var filterHourString = filterHour < 10 ? "0" + filterHour : "" + filterHour;
      var filterMinuteString = filterMinute < 10 ? "0" + filterMinute : "" + filterMinute;

      var filterTime = filterHourString + ":" + filterMinuteString;
      hourFilterPlaceholder.text(filterTime);

      var filterDate = new Date(DKTConfiguration.TAMBORRADA_DAY + "T" + filterTime);
      filteredTamborradas = initialTamborradas.filter(function(tamborrada) {
        return (
          filterDate.getTime() >= tamborrada.startTime.getTime() && filterDate.getTime() <= tamborrada.endTime.getTime()
        );
      });
      applyFilter();
    }
  }

  function applyInitialState() {
    if (isQuarterPage) {
      DKTMap.eraseStartingPoints();
      DKTMap.drawStartingPoints(initialTamborradas);
    } else {
      var grouped = groupByQuarter(initialTamborradas);
      DKTMap.eraseQuarterCount();
      DKTMap.drawQuarterCount(grouped);
    }
    changeParticipantNumber(initialTamborradas);
    hourPopupReposition();
    colorSlider();
  }

  function applyFilter() {
    if (isQuarterPage) {
      DKTMap.eraseStartingPoints();
      DKTMap.drawStartingPoints(filteredTamborradas);
    } else {
      var grouped = groupByQuarter(filteredTamborradas);
      DKTMap.eraseQuarterCount();
      DKTMap.drawQuarterCount(grouped);
    }
    changeParticipantNumber(filteredTamborradas);
    hourPopupReposition();
    colorSlider();
  }

  function groupByQuarter(tamborradas) {
    var grouped = [];
    tamborradas.forEach(function(tamborrada) {
      var zoneId = tamborrada.zoneId;
      var index = -1;
      for (var i = 0; i < grouped.length; i++) {
        var item = grouped[i];
        if (item.zoneId === zoneId) {
          index = i;
          break;
        }
      }
      if (index !== -1) {
        grouped[index].tamborradas.push(tamborrada);
      } else {
        grouped.push({
          zoneId: zoneId,
          tamborradas: [tamborrada]
        });
      }
    });
    return grouped;
  }

  function changeParticipantNumber(tamborradas) {
    var tamborradasTotal = tamborradas.length;

    var participantsTotal = 0;
    var participantsMale = 0;
    var participantsFemale = 0;

    tamborradas.forEach(function(tamborrada) {
      participantsTotal += tamborrada.participants.total;
      participantsMale += tamborrada.participants.male;
      participantsFemale += tamborrada.participants.female;
    });

    $("#tamborradas-total").text(tamborradasTotal);
    $("#participants-total").text(participantsTotal);
    $("#participants-male").text(participantsMale);
    $("#participants-female").text(participantsFemale);
  }

  function hourPopupReposition() {
    var sliderWidth = $("#range_tamborradas").width();
    var actualVal = Number($("#range_tamborradas").val());
    var handlerWidth = 35;
    var newAxisProportion = (sliderWidth - handlerWidth) / sliderWidth;
    var unitaryWidth = sliderWidth / 97;
    var outputWidth = $(".slider-output").outerWidth();
    var actualWidth = actualVal * unitaryWidth * newAxisProportion + handlerWidth / 2 - outputWidth / 2;
    var position = actualWidth + "px";

    $(".slider-output").css("transform", "translate(" + position + ",0px)");
  }

  function colorSlider() {
    var sliderWidth = $("#range_tamborradas").width();
    var actualVal = Number($("#range_tamborradas").val());
    var unitaryWidth = sliderWidth / 97;
    var actualWidth = actualVal * unitaryWidth;
    var handlerWidth = 35;
    var handlerWidthProportion = handlerWidth / sliderWidth;
    var axisLength = 1 - handlerWidthProportion;
    var ratio = ((actualWidth / sliderWidth) * axisLength + handlerWidthProportion / 2) * 100;

    var style = document.getElementById("sliderColorStyle");
    style.innerHTML =
      ".slider::-webkit-slider-runnable-track { background: linear-gradient(90deg, rgba(119, 156, 215, 0.5) " +
      ratio +
      "%, rgba(255, 255, 255,0) 0%); }";
    style.innerHTML +=
      ".slider::-moz-range-track { background: linear-gradient(90deg, rgba(119, 156, 215, 0.5) " +
      ratio +
      "%, rgba(255, 255, 255,0) 0%); }";
    style.innerHTML +=
      ".slider::-ms-track { background: linear-gradient(90deg, rgba(119, 156, 215, 0.5) " +
      ratio +
      "%, rgba(255, 255, 255,0) 0%); }";
  }

  function hourPopupShow() {
    $(".slider-output").removeClass("fade-out");
    if (existeGoogleAnalytics) ga("gtm1.send", "event", "slider hora", "arrastrar", window.location.href);
  }

  function hourPopupHide() {
    $(".slider-output").addClass("fade-out");
  }

  function subscribeSliderListener() {
    var hourFilterSlider = $("#range_tamborradas");
    hourFilterSlider.on("input", filterByHour);
    hourFilterSlider.on("mousedown", hourPopupShow);
    hourFilterSlider.on("touchstart", hourPopupShow);
    hourFilterSlider.on("mouseup", hourPopupHide);
    hourFilterSlider.on("touchend", hourPopupHide);
  }

  function getFilterPositionForActualTime() {
    var now = new Date();
    var time = 0;
    var tamborradaDay = new Date(DKTConfiguration.TAMBORRADA_DAY + "T00:00");

    if (DKTUtils.isSameDay(now, tamborradaDay)) {
      var hour = now.getHours();
      var minute = now.getMinutes();
      var normalizedMinute = Math.floor(minute / 15);
      time = hour * 4 + normalizedMinute + 1;
    }

    return time;
  }

  return {
    init: init,
    initQuarterPage: initQuarterPage
  };
};
